import { useMenu } from 'react-instantsearch';

import InstantSearchAccordion from './units/instantSearchAccordion';
import InstantSearchFilterOption from './units/instantSearchFilterOption';

import type { FilterProps } from '@javascript/types/InstantSearch';

const SingleSelectFilter = ({
  attribute,
  label,
  sortBy,
  filtersOpen,
}: FilterProps) => {
  const { items, refine } = useMenu({
    attribute: attribute,
    sortBy,
  });

  if (items.length === 0) return null;

  const selectedItem = items.find(
    (item) => item.isRefined && item.label !== 'Any'
  );
  const selectedOption = selectedItem ? selectedItem.label : '';

  return (
    <>
      <InstantSearchAccordion
        filtersOpen={filtersOpen}
        label={label}
        selectedOptions={selectedOption}
      >
        <ul>
          <InstantSearchFilterOption.Any attribute={attribute} />
          {items.map((item) => (
            <InstantSearchFilterOption.Radio
              attribute={attribute}
              count={item.count}
              isSelected={item.isRefined}
              key={`${attribute}-${item.label}`}
              label={item.label}
              onChange={() => refine(item.value)}
            />
          ))}
        </ul>
      </InstantSearchAccordion>
    </>
  );
};

export default SingleSelectFilter;
